<template>
  <FactureCard>
    <template v-slot:title>Payer par Moneris Checkout</template>
    <SousTotalRowPaiement title="Total avant taxes" :montant="formatPrix(facture.montantHT)" />
    <SousTotalRowPaiement v-if="facture.rabais > 0" title="Rabais" :montant="formatPrix(facture.rabais)" />
    <SousTotalRowPaiement v-for="taxe in facture.taxes" :key="taxe.code" :title="taxe.code" :montant="formatPrix(taxe.montant)" />
    <SousTotalRowPaiement title="Total" :montant="formatPrix(facture.total)" />
    <SousTotalRowPaiement title="Déjà payé" :montant="formatPrix(facture.dejaPaye)" />
    <p class="title primary--text my-6">
      Solde: <span class="font-weight-bold">{{ formatPrix(facture.solde) }}</span>
    </p>

    <div class="inputFields" v-if="inputFields">
      <v-text-field label="Numéro de carte" outlined placeholder="1234 1234 1234 1234" dense append-icon="mdi-credit-card" v-model="carte.numeroCarte"></v-text-field>
      <v-text-field label="Expiration" outlined placeholder="MM / AA" dense append-icon="mdi-calendar-range" v-model="carte.expiration"></v-text-field>
      <v-text-field label="CVV" outlined dense placeholder="123" append-icon="mdi-numeric" v-model="carte.cvv"></v-text-field>
    </div>
    <slot name="btn-paiement">
      <v-btn rounded color="success" @click="payerClicked">{{ labelBouton }}</v-btn>
    </slot>
  </FactureCard>
</template>

<script>
import FactureCard from "./FactureCard"
import SousTotalRowPaiement from "./SousTotalRowPaiement"

export default {
  components: { FactureCard, SousTotalRowPaiement },
  data() {
    return {
      carte: {
        numeroCarte: "",
        expiration: "",
        cvv: ""
      }
    }
  },
  props: {
    inputFields: {
      type: Boolean,
      default: false
    },
    formatPrix: {
      type: Function
    },
    facture: Object,
    labelBouton: String,
  },
  methods: {
    payerClicked() {
      this.$emit("payerClicked", this.carte)
    }
  }
}
</script>

<style scoped>
.solde {
  font-size: 1.5em;
}

.solde--montant {
  font-weight: bold;
}
</style>